import { render, staticRenderFns } from "./studioSignatures.vue?vue&type=template&id=9b810c0e&scoped=true"
import script from "./studioSignatures.vue?vue&type=script&lang=js"
export * from "./studioSignatures.vue?vue&type=script&lang=js"
import style0 from "./studioSignatures.vue?vue&type=style&index=0&id=9b810c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b810c0e",
  null
  
)

export default component.exports